import React, { ForwardedRef } from "react";

import { CircleIconProps } from "./CircleIcon.types";
import { useStyles } from "./CircleIconStyles";

function CircleIcon(
  props: CircleIconProps,
  ref: ForwardedRef<HTMLDivElement>
): JSX.Element {
  const { children } = props;

  const classes = useStyles(props);

  return (
    <div className={classes.root} ref={ref}>
      {children}
    </div>
  );
}

export default React.forwardRef(CircleIcon);
